<template>
  <div class="login-container">
    <!-- 动态背景元素 -->
    <div class="background-elements">
      <!-- 浮动的医疗元素 -->
      <div class="floating-element element-1">
        <div class="medical-cross"></div>
      </div>
      <div class="floating-element element-2">
        <div class="pulse-circle"></div>
      </div>
      <div class="floating-element element-3">
        <div class="dna-helix"></div>
      </div>
      <div class="floating-element element-4">
        <div class="heartbeat-line"></div>
      </div>
      <div class="floating-element element-5">
        <div class="medical-pill"></div>
      </div>
      <div class="floating-element element-6">
        <div class="stethoscope"></div>
      </div>
      
      <!-- 网格装饰 -->
      <div class="grid-pattern"></div>
      
      <!-- 渐变装饰球 -->
      <div class="decoration-orb orb-1"></div>
      <div class="decoration-orb orb-2"></div>
      <div class="decoration-orb orb-3"></div>
        </div>

    <div class="login-wrapper">
      <div class="login-card">


        <!-- 简约左右分栏表单 -->
        <div class="elegant-form">
          <!-- 左侧信息区域 -->
          <div class="form-left">
            <div class="brand-section">
              <div class="brand-logo">
                <svg class="logo-icon" viewBox="0 0 24 24">
                  <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"/>
                </svg>
        </div>
              <h2 class="brand-title">HIV药品管理</h2>
              <p class="brand-subtitle">Medical Management Platform</p>
        </div>

            <div class="info-content">
              <div class="feature-list">
                <div class="feature-item">
                  <svg class="feature-icon" viewBox="0 0 24 24">
                    <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z"/>
                  </svg>
                  <span class="feature-text">安全加密传输</span>
                </div>

              </div>
            </div>
          </div>

          <!-- 右侧登录表单 -->
          <div class="form-right">
            <div class="login-header">
              <h3 class="login-title">系统登录</h3>
              <p class="login-desc">请使用您的凭据登录系统</p>
            </div>

            <el-form class="login-form" ref="loginForm" :model="rulesForm" :rules="formRules">
              <!-- 用户名 -->
              <div v-if="loginType==1" class="form-group">
                <el-form-item prop="username">
                  <div class="input-wrapper">
                    <label class="input-label">用户名</label>
                    <div class="input-field">
                      <svg class="field-icon" viewBox="0 0 24 24">
                        <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
                      </svg>
                      <input 
                        class="form-input"
                        placeholder="请输入用户名" 
                        name="username" 
                        type="text" 
                        v-model="rulesForm.username"
                        autocomplete="username"
                        @blur="validateUsername"
                        :class="{ 'error': usernameError, 'success': usernameValid }"
                      >
                      <div class="field-status">
                        <svg v-if="usernameValid" class="status-icon success" viewBox="0 0 24 24">
                          <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
                        </svg>
                        <svg v-if="usernameError" class="status-icon error" viewBox="0 0 24 24">
                          <path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
                        </svg>
                      </div>
                    </div>
                    <div v-if="usernameError" class="error-tip">{{usernameErrorMsg}}</div>
                  </div>
                </el-form-item>
              </div>

              <!-- 密码 -->
              <div v-if="loginType==1" class="form-group">
                <el-form-item prop="password">
                  <div class="input-wrapper">
                    <label class="input-label">密码</label>
                    <div class="input-field">
                      <svg class="field-icon" viewBox="0 0 24 24">
                        <path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
                      </svg>
                      <input 
                        class="form-input"
                        placeholder="请输入密码" 
                        name="password" 
                        :type="showPassword ? 'text' : 'password'"
                        v-model="rulesForm.password"
                        autocomplete="current-password"
                        @blur="validatePassword"
                        :class="{ 'error': passwordError, 'success': passwordValid }"
                      >
                      <div class="field-actions">
                        <button type="button" class="toggle-btn" @click="showPassword = !showPassword">
                          <svg v-if="!showPassword" class="toggle-icon" viewBox="0 0 24 24">
                            <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
                          </svg>
                          <svg v-else class="toggle-icon" viewBox="0 0 24 24">
                            <path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.09L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.76,7.13 11.37,7 12,7Z"/>
                          </svg>
                        </button>
                        <div class="strength-bar">
                          <div class="strength-fill" :class="passwordStrength"></div>
                        </div>
                      </div>
                    </div>
                    <div v-if="passwordError" class="error-tip">{{passwordErrorMsg}}</div>
                  </div>
                </el-form-item>
              </div>

              

              <!-- 登录按钮 -->
              <div class="form-group">
                <el-button 
                  v-if="loginType==1"
                  type="primary" 
                  @click="login()" 
                  class="login-btn"
                  :loading="loginLoading"
                  :disabled="!canLogin"
                >
                  <span v-if="!loginLoading">登录</span>
                  <span v-else>验证中...</span>
                </el-button>
        </div>
      </el-form>

          </div>
        </div>

        <!-- 底部安全提示 -->
        <div class="security-footer">
          <div class="security-badge">
            <svg class="security-icon" viewBox="0 0 24 24">
              <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5C15.4,11.5 16,12.4 16,13V16C16,17.4 15.4,18 14.8,18H9.2C8.6,18 8,17.4 8,16V13C8,12.4 8.6,11.5 9.2,11.5V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,10V11.5H13.5V10C13.5,8.7 12.8,8.2 12,8.2Z"/>
            </svg>
            <div class="security-text">
              <span class="security-title">安全认证</span>
              <span class="security-desc">数据传输已加密</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menu from "@/utils/menu";

export default {
  data() {
    return {
      baseUrl: this.$base.url,
      loginType: 1,
      loginLoading: false,
      showPassword: false,
      usernameError: false,
      usernameErrorMsg: '',
      usernameValid: false,
      passwordError: false,
      passwordErrorMsg: '',
      passwordValid: false,
      passwordStrength: 'weak',
      rulesForm: {
        username: "",
        password: "",
        role: "",
        code: '',
      },
      formRules: {
        username: [
          { required: true, message: '请输入用户标识', trigger: 'blur' },
          { min: 3, max: 20, message: '用户标识长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, message: '密码长度不能少于 5 个字符', trigger: 'blur' }
        ]
      },
      menus: [],
      roles: [],
      tableName: "",
      codes: [{
        num: 1,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      },{
        num: 2,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      },{
        num: 3,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      },{
        num: 4,
        color: '#000',
        rotate: '10deg',
        size: '16px'
      }],
    };
  },
  computed: {
    canLogin() {
      return this.rulesForm.username && 
             this.rulesForm.password && 
             !this.usernameError && 
             !this.passwordError &&
             (this.roles.length <= 1 || this.rulesForm.role);
    }
  },
  mounted() {
    let menus = menu.list();
    this.menus = menus;

    for (let i = 0; i < this.menus.length; i++) {
      if (this.menus[i].hasBackLogin=='是') {
        this.roles.push(this.menus[i])
      }
    }
  },
  created() {
    this.getRandCode()
  },
  destroyed() {
	    },
  methods: {
    //注册
    register(tableName){
		this.$storage.set("loginTable", tableName);
        this.$storage.set("pageFlag", "register");
		this.$router.push({path:'/register'})
    },
    // 验证用户名
    validateUsername() {
      this.usernameError = false;
      this.usernameValid = false;
      this.usernameErrorMsg = '';

      if (!this.rulesForm.username) {
        this.usernameError = true;
        this.usernameErrorMsg = '请输入用户标识';
        return;
      }

      if (this.rulesForm.username.length < 3) {
        this.usernameError = true;
        this.usernameErrorMsg = '用户标识长度不能少于3个字符';
        return;
      }

      if (this.rulesForm.username.length > 20) {
        this.usernameError = true;
        this.usernameErrorMsg = '用户标识长度不能超过20个字符';
        return;
      }

      // 验证格式（字母数字下划线）
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(this.rulesForm.username)) {
        this.usernameError = true;
        this.usernameErrorMsg = '用户标识只能包含字母、数字和下划线';
        return;
      }

      this.usernameValid = true;
    },
    // 验证密码
    validatePassword() {
      this.passwordError = false;
      this.passwordValid = false;
      this.passwordErrorMsg = '';

      if (!this.rulesForm.password) {
        this.passwordError = true;
        this.passwordErrorMsg = '请输入安全密码';
        this.passwordStrength = 'weak';
        return;
      }

      if (this.rulesForm.password.length < 5) {
        this.passwordError = true;
        this.passwordErrorMsg = '密码长度不能少于5个字符';
        this.passwordStrength = 'weak';
        return;
      }

      // 计算密码强度
      this.calculatePasswordStrength();
      this.passwordValid = true;
    },
    // 计算密码强度
    calculatePasswordStrength() {
      const password = this.rulesForm.password;
      let score = 0;

      // 长度
      if (password.length >= 8) score += 1;
      if (password.length >= 12) score += 1;

      // 包含数字
      if (/\d/.test(password)) score += 1;

      // 包含小写字母
      if (/[a-z]/.test(password)) score += 1;

      // 包含大写字母
      if (/[A-Z]/.test(password)) score += 1;

      // 包含特殊字符
      if (/[^a-zA-Z0-9]/.test(password)) score += 1;

      if (score <= 2) {
        this.passwordStrength = 'weak';
      } else if (score <= 4) {
        this.passwordStrength = 'medium';
      } else {
        this.passwordStrength = 'strong';
      }
    },
    // 选择角色
    selectRole(item) {
      this.rulesForm.role = item.roleName;
    },
    // 获取角色描述
    getRoleDescription(roleName) {
      const descriptions = {
        '管理员': '系统管理权限',
        '医生': '医疗诊断权限',
        '护士': '护理操作权限',
        '药师': '药品管理权限',
        '检验师': '检验报告权限'
      };
      return descriptions[roleName] || '专业医疗权限';
    },
    // 登陆
    login() {
		if (!this.rulesForm.username) {
			this.$message.error("请输入用户名");
			return;
		}
		if (!this.rulesForm.password) {
			this.$message.error("请输入密码");
			return;
		}
		if(this.roles.length>1) {
			if (!this.rulesForm.role) {
				this.$message.error("请选择角色");
				return;
			}

			let menus = this.menus;
			for (let i = 0; i < menus.length; i++) {
				if (menus[i].roleName == this.rulesForm.role) {
					this.tableName = menus[i].tableName;
				}
			}
		} else {
			this.tableName = this.roles[0].tableName;
			this.rulesForm.role = this.roles[0].roleName;
		}

      this.loginLoading = true;

		// 使用 URLSearchParams 确保以表单格式发送
		const formData = new URLSearchParams();
		formData.append('username', this.rulesForm.username);
		formData.append('password', this.rulesForm.password);

		this.$http({
			url: `${this.tableName}/login`,
			method: "post",
			data: formData,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then(({ data }) => {
        this.loginLoading = false;
			if (data && data.code === 0) {
				this.$storage.set("Token", data.token);
				this.$storage.set("role", this.rulesForm.role);
				this.$storage.set("sessionTable", this.tableName);
				this.$storage.set("adminName", this.rulesForm.username);
				this.$router.replace({ path: "/index/" });
			} else {
				this.$message.error(data.msg);
			}
      }).catch(() => {
        this.loginLoading = false;
        this.$message.error("登录失败，请重试");
		});
    },
    getRandCode(len = 4){
		this.randomString(len)
    },
    randomString(len = 4) {
      let chars = [
          "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k",
          "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v",
          "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G",
          "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R",
          "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2",
          "3", "4", "5", "6", "7", "8", "9"
      ]
      let colors = ["0", "1", "2","3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"]
      let sizes = ['14', '15', '16', '17', '18']

      let output = [];
      for (let i = 0; i < len; i++) {
        // 随机验证码
        let key = Math.floor(Math.random()*chars.length)
        this.codes[i].num = chars[key]
        // 随机验证码颜色
        let code = '#'
        for (let j = 0; j < 6; j++) {
          let key = Math.floor(Math.random()*colors.length)
          code += colors[key]
        }
        this.codes[i].color = code
        // 随机验证码方向
        let rotate = Math.floor(Math.random()*60)
        let plus = Math.floor(Math.random()*2)
        if(plus == 1) rotate = '-'+rotate
        this.codes[i].rotate = 'rotate('+rotate+'deg)'
        // 随机验证码字体大小
        let size = Math.floor(Math.random()*sizes.length)
        this.codes[i].size = sizes[size]+'px'
      }
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  padding: 20px 0;
}

// 动态背景元素
.background-elements {
  position: absolute;
  top: 0;
  left: 0;
		width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;

  .grid-pattern {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(rgba(66, 153, 225, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(66, 153, 225, 0.05) 1px, transparent 1px);
    background-size: 50px 50px;
    animation: gridMove 20s linear infinite;
  }

  .floating-element {
    position: absolute;
    opacity: 0.1;
    animation-duration: 15s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;

    &.element-1 {
      top: 10%;
      left: 10%;
      animation-name: float1;
      animation-delay: 0s;
    }

    &.element-2 {
      top: 20%;
      right: 15%;
      animation-name: float2;
      animation-delay: 2s;
    }

    &.element-3 {
      bottom: 20%;
      left: 20%;
      animation-name: float3;
      animation-delay: 4s;
    }

    &.element-4 {
      top: 60%;
      right: 10%;
      animation-name: float4;
      animation-delay: 1s;
    }

    &.element-5 {
      bottom: 30%;
      right: 25%;
      animation-name: float5;
      animation-delay: 3s;
    }

    &.element-6 {
      top: 40%;
      left: 5%;
      animation-name: float6;
      animation-delay: 5s;
    }

    .medical-cross {
      width: 40px;
      height: 40px;
      position: relative;

      &::before, &::after {
        content: '';
        position: absolute;
        background: #4299e1;
        border-radius: 2px;
      }

      &::before {
        width: 6px;
        height: 40px;
        left: 50%;
        transform: translateX(-50%);
      }

      &::after {
        width: 40px;
        height: 6px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .pulse-circle {
      width: 60px;
      height: 60px;
      border: 3px solid #4299e1;
      border-radius: 50%;
      position: relative;
      animation: pulse 2s infinite;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        background: #4299e1;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .dna-helix {
      width: 30px;
      height: 80px;
      position: relative;

      &::before, &::after {
        content: '';
        position: absolute;
        width: 4px;
        height: 100%;
        background: linear-gradient(to bottom, #4299e1 0%, transparent 50%, #4299e1 100%);
        border-radius: 2px;
      }

      &::before {
        left: 0;
        transform: rotate(15deg);
      }

      &::after {
        right: 0;
        transform: rotate(-15deg);
      }
    }

    .heartbeat-line {
      width: 100px;
      height: 40px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
  	  	width: 100%;
        height: 2px;
        background: #4299e1;
        transform: translateY(-50%);
  	  }

      &::after {
        content: '';
		position: absolute;
        top: 10px;
        left: 20px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 20px solid #4299e1;
      }
    }

    .medical-pill {
      width: 50px;
      height: 20px;
      background: linear-gradient(90deg, #4299e1 50%, #63b3ed 50%);
      border-radius: 25px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 2px;
        height: 100%;
        background: rgba(255, 255, 255, 0.3);
        transform: translateX(-50%);
      }
    }

    .stethoscope {
      width: 60px;
      height: 60px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 10px;
        left: 10px;
        width: 40px;
        height: 40px;
        border: 3px solid #4299e1;
        border-radius: 50%;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 3px;
        height: 20px;
        background: #4299e1;
        transform: translateX(-50%);
        border-radius: 2px;
      }
    }
  }

  .decoration-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(1px);
    animation: orbFloat 10s ease-in-out infinite;

    &.orb-1 {
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(66, 153, 225, 0.05) 0%, transparent 70%);
      top: -100px;
      left: -100px;
      animation-delay: 0s;
    }

    &.orb-2 {
      width: 150px;
      height: 150px;
      background: radial-gradient(circle, rgba(129, 140, 248, 0.04) 0%, transparent 70%);
      bottom: -75px;
      right: -75px;
      animation-delay: 3s;
    }

    &.orb-3 {
      width: 100px;
      height: 100px;
      background: radial-gradient(circle, rgba(99, 179, 237, 0.06) 0%, transparent 70%);
      top: 30%;
      left: -50px;
      animation-delay: 6s;
    }
  }
}

// 动画定义
@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

@keyframes float1 {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translateX(0px) rotate(0deg); }
  50% { transform: translateX(-15px) rotate(-90deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0px, 0px) rotate(0deg); }
  50% { transform: translate(10px, -15px) rotate(45deg); }
}

@keyframes float4 {
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-25px) scale(1.1); }
}

@keyframes float5 {
  0%, 100% { transform: rotate(0deg) translateY(0px); }
  50% { transform: rotate(360deg) translateY(-10px); }
}

@keyframes float6 {
  0%, 100% { transform: translateX(0px) translateY(0px); }
  25% { transform: translateX(10px) translateY(-10px); }
  75% { transform: translateX(-10px) translateY(10px); }
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -30px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
}

// 登录卡片
.login-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 920px;
  max-height: 95vh;
  padding: 20px;
}

.login-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 30px 25px;
  box-shadow: 
    0 15px 35px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(226, 232, 240, 0.8);
  position: relative;
  backdrop-filter: blur(10px);
  width: 100%;
  max-height: 95vh;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #4299e1 0%, #63b3ed 50%, #4299e1 100%);
    border-radius: 20px 20px 0 0;
  }
}

// 头部区域
.header-section {
  text-align: center;
  margin-bottom: 45px;
}

.logo-container {
  margin-bottom: 30px;
}

.medical-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 10px 30px rgba(66, 153, 225, 0.3);
  margin-bottom: 25px;

  .logo-cross {
    position: relative;
    width: 35px;
    height: 35px;

    .cross-vertical, .cross-horizontal {
      position: absolute;
      background: white;
      border-radius: 3px;
    }

    .cross-vertical {
      width: 5px;
      height: 35px;
      left: 50%;
      transform: translateX(-50%);
    }

    .cross-horizontal {
      width: 35px;
      height: 5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .logo-pulse {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid rgba(66, 153, 225, 0.3);
    border-radius: 50%;
    animation: logoPulse 2s ease-in-out infinite;
  }
}

@keyframes logoPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.5; }
}

.system-title {
  font-size: 32px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
}

.system-subtitle {
  font-size: 16px;
  color: #718096;
  margin: 0 0 20px 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.title-divider {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #4299e1 0%, #63b3ed 100%);
  border-radius: 2px;
  margin: 0 auto;
}

// 简约左右分栏表单
.elegant-form {
  display: flex;
  min-height: 500px;
  max-height: 90vh;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  background: white;

  // 左侧信息区域
  .form-left {
    flex: 0 0 45%;
    background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
    padding: 40px 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -30%;
      right: -15%;
      width: 80%;
      height: 150%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      border-radius: 50%;
    }

    .brand-section {
      text-align: center;
      position: relative;
      z-index: 1;

      .brand-logo {
        width: 70px;
        height: 70px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 25px;
        backdrop-filter: blur(10px);

        .logo-icon {
          width: 35px;
          height: 35px;
          fill: white;
        }
      }

      .brand-title {
        font-size: 28px;
        font-weight: 700;
        margin: 0 0 10px 0;
        letter-spacing: -0.5px;
      }

      .brand-subtitle {
		font-size: 14px;
        opacity: 0.9;
        margin: 0;
        font-weight: 400;
      }
    }

    .info-content {
      position: relative;
      z-index: 1;
      margin-top: 30px;

      .feature-list {
        .feature-item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 12px 0;
          opacity: 0.9;

          .feature-icon {
            width: 20px;
            height: 20px;
            fill: rgba(255, 255, 255, 0.8);
            flex-shrink: 0;
          }

          .feature-text {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }
  }

  // 右侧登录表单
  .form-right {
    flex: 1;
    padding: 40px 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 100vh;
    overflow-y: auto;

    .login-header {
      text-align: center;
      margin-bottom: 30px;

      .login-title {
        font-size: 24px;
        font-weight: 700;
        color: #2d3748;
        margin: 0 0 6px 0;
      }

      .login-desc {
        font-size: 14px;
        color: #718096;
        margin: 0;
      }
    }

    .login-form {
      .form-group {
        margin-bottom: 20px;

        .input-wrapper {
          .input-label {
        display: block;
            font-size: 13px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 6px;
          }

          .input-field {
            position: relative;
            display: flex;
            align-items: center;
            background: #f9fafb;
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            transition: all 0.3s ease;

            &:focus-within {
              border-color: #4299e1;
              background: white;
              box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
            }

            .field-icon {
              width: 18px;
              height: 18px;
              fill: #9ca3af;
              margin-left: 14px;
              flex-shrink: 0;
              transition: all 0.3s ease;
            }

            &:focus-within .field-icon {
              fill: #4299e1;
            }

            .form-input {
              flex: 1;
              height: 46px;
              padding: 0 14px;
              border: none;
              outline: none;
              background: transparent;
              font-size: 15px;
              color: #374151;
              font-weight: 500;

              &::placeholder {
                color: #9ca3af;
                font-weight: 400;
              }

              &.error {
                color: #ef4444;
              }

              &.success {
                color: #10b981;
              }
            }

            .field-status {
              margin-right: 14px;

              .status-icon {
                width: 16px;
                height: 16px;

                &.success {
                  fill: #10b981;
                }

                &.error {
                  fill: #ef4444;
                }
              }
            }

            .field-actions {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-right: 14px;

              .toggle-btn {
                background: none;
                border: none;
                cursor: pointer;
                padding: 3px;
                border-radius: 4px;
                transition: all 0.2s ease;

                &:hover {
                  background: #f3f4f6;
                }

                .toggle-icon {
                  width: 16px;
                  height: 16px;
                  fill: #6b7280;
                }
              }

              .strength-bar {
                width: 40px;
                height: 2px;
                background: #e5e7eb;
                border-radius: 1px;
                overflow: hidden;

                .strength-fill {
                  height: 100%;
                  border-radius: 1px;
                  transition: all 0.3s ease;

                  &.weak {
                    width: 33%;
                    background: #ef4444;
                  }

                  &.medium {
                    width: 66%;
                    background: #f59e0b;
                  }

                  &.strong {
                    width: 100%;
                    background: #10b981;
                  }
                }
              }
            }
          }

          .error-tip {
            margin-top: 4px;
            font-size: 12px;
            color: #ef4444;
            display: flex;
            align-items: center;
            gap: 3px;
          }
        }

        .login-btn {
          width: 100%;
          height: 46px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
          color: white;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 3px 10px rgba(66, 153, 225, 0.4);

          &:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 5px 15px rgba(66, 153, 225, 0.5);
          }

          &:active:not(:disabled) {
            transform: translateY(0);
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
          }
        }
      }
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 安全提示
.security-footer {
  margin-top: 35px;
  padding-top: 25px;
  border-top: 1px solid #e2e8f0;
}

.security-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 50px;
  border: 1px solid #cbd5e0;

  .security-icon {
    width: 24px;
    height: 24px;
    fill: #4299e1;
    flex-shrink: 0;
  }

  .security-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .security-title {
      font-size: 13px;
      font-weight: 600;
      color: #4a5568;
      line-height: 1;
    }

    .security-desc {
      font-size: 11px;
      color: #718096;
      line-height: 1;
      margin-top: 2px;
    }
  }
}

// Element UI 专业样式覆盖
/deep/ .el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form-item__content {
  line-height: normal;
}

/deep/ .el-form-item__error {
  display: none; // 使用自定义错误样式
}

/deep/ .el-button--primary {
  background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
  border: none;

  &:hover, &:focus {
    background: linear-gradient(135deg, #4299e1 0%, #63b3ed 100%);
  }

  &:disabled {
    background: linear-gradient(135deg, #a0aec0 0%, #cbd5e0 100%);
    opacity: 0.6;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .login-wrapper {
    max-width: 500px;
    padding: 15px;
  }

  .login-card {
    padding: 20px;
    max-height: 95vh;
  }

  .elegant-form {
    flex-direction: column;
    min-height: auto;
    max-height: none;

    .form-left {
      flex: none;
      padding: 25px 20px;

      .brand-section {
        .brand-logo {
          width: 60px;
          height: 60px;
          margin-bottom: 15px;

          .logo-icon {
            width: 30px;
            height: 30px;
          }
        }

        .brand-title {
          font-size: 22px;
        }

        .brand-subtitle {
          font-size: 13px;
        }
      }

      .info-content {
        margin-top: 20px;

        .feature-list .feature-item {
          padding: 8px 0;
          justify-content: center;

          .feature-icon {
            width: 18px;
            height: 18px;
          }

          .feature-text {
            font-size: 13px;
          }
        }
      }
    }

    .form-right {
      flex: none;
      padding: 25px 20px;
      max-height: none;
      overflow-y: visible;

      .login-header {
        margin-bottom: 20px;

        .login-title {
          font-size: 20px;
        }

        .login-desc {
          font-size: 13px;
        }
      }

      .login-form .form-group {
        margin-bottom: 16px;

        .input-wrapper {
          .input-label {
            font-size: 12px;
            margin-bottom: 5px;
          }

          .input-field {
            .field-icon {
              width: 16px;
              height: 16px;
              margin-left: 12px;
            }

            .form-input {
              height: 42px;
              padding: 0 12px;
        font-size: 14px;
            }

            .field-status {
              margin-right: 12px;

              .status-icon {
                width: 14px;
                height: 14px;
              }
            }

            .field-actions {
              margin-right: 12px;

              .toggle-btn .toggle-icon {
                width: 14px;
                height: 14px;
              }

              .strength-bar {
                width: 35px;
                height: 2px;
              }
            }
          }

          .error-tip {
            font-size: 11px;
            margin-top: 3px;
          }
        }

        .login-btn {
          height: 42px;
          font-size: 14px;
        }
      }
    }
  }

  .background-elements .floating-element {
    display: none;
  }
}

@media (max-width: 480px) {
  .login-wrapper {
    max-width: 100%;
    padding: 10px;
  }

  .login-card {
    padding: 15px;
    border-radius: 15px;
    max-height: 95vh;
    overflow-y: auto;
  }

  .elegant-form {
    .form-left {
      padding: 20px 15px;

      .brand-section {
        .brand-logo {
          width: 50px;
          height: 50px;
          margin-bottom: 12px;

          .logo-icon {
            width: 25px;
            height: 25px;
          }
        }

        .brand-title {
          font-size: 18px;
        }

        .brand-subtitle {
          font-size: 12px;
        }
      }

      .info-content {
        margin-top: 15px;

        .feature-list .feature-item {
          padding: 6px 0;

          .feature-icon {
            width: 16px;
            height: 16px;
          }

          .feature-text {
            font-size: 12px;
          }
        }
      }
    }

    .form-right {
      padding: 20px 15px;

      .login-header {
        margin-bottom: 15px;

        .login-title {
          font-size: 18px;
        }

        .login-desc {
          font-size: 12px;
        }
      }

      .login-form .form-group {
        margin-bottom: 14px;

        .input-wrapper {
          .input-label {
            font-size: 11px;
            margin-bottom: 4px;
          }

          .input-field {
            border-radius: 8px;

            .field-icon {
              width: 14px;
              height: 14px;
              margin-left: 10px;
            }

            .form-input {
              height: 40px;
              padding: 0 10px;
              font-size: 13px;
            }

            .field-status {
              margin-right: 10px;

              .status-icon {
                width: 12px;
                height: 12px;
              }
            }

            .field-actions {
              margin-right: 10px;

              .toggle-btn .toggle-icon {
                width: 12px;
                height: 12px;
              }

              .strength-bar {
                width: 30px;
                height: 2px;
              }
            }
          }

          .error-tip {
            font-size: 10px;
          }
        }

        .login-btn {
          height: 40px;
          font-size: 13px;
          border-radius: 8px;
        }
      }
    }
      }
}
</style>


